module.exports = __webpack_public_path__ + "static/media/1POLICY7.958e2e5d.jpg";